import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { customerQuery } from "../services/Api";
import { Empty, Flex, Spin } from "antd";

const UserAllQuery = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [querys, setQuerys] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const user_id = location.state?.user_id;

    const getAllQuery = useCallback(async () => {
        setIsLoading(true);
        try {
            const response = await customerQuery(null, null, null, user_id);
            setQuerys(response.data.data[0]);
        } catch (error) {
            // optionally log or handle error
        } finally {
            setIsLoading(false);
        }
    }, [user_id]);

    useEffect(() => {
        getAllQuery();
    }, [getAllQuery]);

    return (
        <div className="  space-y-6 px-5 sm:px-10 md:px-20 py-5 ">
            <div className="space-y-6">
                <div className="flex flex-col space-y-4">
                    <div className="flex justify-between">
                        <p className="text-2xl font-semibold">Help and Support</p>
                    </div>
                </div>
                <button className="flex items-center w-fit bg-[#E53935] px-2 py-1 rounded-md active:scale-95 duration-500" onClick={() => navigate(-1)}>
                    <svg width="20" height="20" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5516 21.3393H30.2057C30.6543 21.3393 31.0304 21.1875 31.3339 20.8841C31.6373 20.5806 31.7891 20.2045 31.7891 19.7559C31.7891 19.3073 31.6373 18.9313 31.3339 18.6278C31.0304 18.3243 30.6543 18.1726 30.2057 18.1726H12.5516L17.0641 13.6601C17.3807 13.3434 17.5325 12.974 17.5193 12.5518C17.5061 12.1295 17.3543 11.7601 17.0641 11.4434C16.7474 11.1268 16.3714 10.9618 15.9359 10.9486C15.5005 10.9354 15.1245 11.0872 14.8078 11.4038L7.56406 18.6476C7.40573 18.8059 7.29358 18.9775 7.2276 19.1622C7.16163 19.3469 7.12865 19.5448 7.12865 19.7559C7.12865 19.967 7.16163 20.165 7.2276 20.3497C7.29358 20.5344 7.40573 20.7059 7.56406 20.8643L14.8078 28.108C15.1245 28.4247 15.5005 28.5764 15.9359 28.5632C16.3714 28.55 16.7474 28.3851 17.0641 28.0684C17.3543 27.7518 17.5061 27.3823 17.5193 26.9601C17.5325 26.5379 17.3807 26.1684 17.0641 25.8518L12.5516 21.3393Z" fill="white" />
                    </svg>
                    <button className="">
                        <span className=" text-white ms-1">Back</span>
                    </button>
                </button>
                {isLoading ?
                    <div className='mt-20 flex justify-center items-center'>
                        <Flex gap="middle" vertical>
                            <Spin tip="Loading" size="large">
                                <div className='p-12 rounded-xl'></div>
                            </Spin>
                        </Flex>
                    </div>
                    : (
                        querys?.queries?.length > 0 ? (
                            <div className="border rounded-lg border-blue-200">
                                {querys?.queries.map((queries, index) => (
                                    <div
                                        key={index}
                                        className={`px-4 py-2 ${index !== queries.length - 1 ? 'border-b border-blue-200' : ''
                                            }`}
                                    >
                                        <div className="block sm:flex justify-between items-center">
                                            <div>
                                                <p className="text-base font-semibold text-gray-600 break-words">
                                                    {queries?.message}
                                                </p>
                                                {queries?.reply_by_admin &&
                                                    <p className="text-sm text-gray-500 break-words ms-5">
                                                        {queries?.answer}
                                                    </p>
                                                }
                                            </div>
                                            <div className="block sm:flex items-center gap-10">
                                                <div className="flex sm:block space-x-5 sm:space-x-0 my-3 sm:my-0">
                                                    <p className="text-sm text-gray-500 whitespace-nowrap mb-2">
                                                        {moment(queries?.time).format('MMM DD')}
                                                    </p>
                                                    <p className="text-sm text-gray-500 whitespace-nowrap mb-2">
                                                        {moment(queries?.time).format('LT')}
                                                    </p>
                                                </div>
                                                <div className=" flex sm:block justify-end">
                                                    {
                                                        queries?.reply_by_admin === false ? (
                                                            <button className="bg-green-600 text-white py-1 px-3 rounded-md active:scale-95 duration-500" onClick={() => navigate('/admin/helpreply', { state: { user_id: user_id, query_id: querys._id, queries: queries } })}>Reply</button>
                                                        ) : (
                                                            <p className=" text-red-500 py-1 px-3 rounded-md" disabled >Replied</p>
                                                        )
                                                    }
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (<Empty />)
                    )
                }

            </div>
        </div>
    )
}
export default UserAllQuery;